// 启动自愈:校验 localStorage 中 vuex-along 持久化数据是否为完整 JSON。
// state 过大撑爆 5MB 配额时,setItem 可能留下截断的残缺 JSON,
// 下次启动 lowdb 初始化 JSON.parse 会失败,并使 this.db 为 undefined。
// 此处提前检测并清除,保证 vuex-along 正常初始化。
// 注意:必须作为 main.js 的首个 import,先于 store/index.js(vuex-along 初始化)执行。
const VUEX_ALONG_KEY = 'vuex-along';
try {
  const raw = window.localStorage.getItem(VUEX_ALONG_KEY);
  if (raw) {
    JSON.parse(raw); // 能解析说明数据完整,保留
  }
} catch (e) {
  window.localStorage.removeItem(VUEX_ALONG_KEY);
}



// WEBPACK FOOTER //
// ./src/utils/vuexAlongSelfHeal.js